import SidebarFavoritesDisplaySection from "@/infrastructure/Sidebar/SidebarFavorites/sidebarFavoritesDisplaySection.component";
import SidebarFavoritesDraggableSection from "@/infrastructure/Sidebar/SidebarFavorites/sidebarFavoritesDraggableSection.component";
import { AppContext } from "@/services/AppContext/appContext";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { FavoriteSearch } from "@/types";
import { Ban, Pencil, Save, Star } from "lucide-react";
import React, { useContext, useEffect, useState } from "react";

type SidebarFavoritesProps = {
  currPage: string;
};

const SidebarFavorites: React.FC<SidebarFavoritesProps> = ({ currPage }) => {
  const {
    favoriteSearches,
    updateFavoriteSearches,
    initialGetUserFavoriteSearches,
  } = useContext(AppContext);

  const [editing, setEditing] = useState(false);
  const [editingSearches, setEditingSearches] = useState<FavoriteSearch[]>([]);

  async function handleSaveClick() {
    console.log("Saving favorite searches:", editingSearches);
    setEditing(false);
    await updateFavoriteSearches([...editingSearches]);
  }

  function handleCancelClick() {
    setEditing(false);
    // get from local storage to fix the issue with unwanted global state updates
    initialGetUserFavoriteSearches({ force: true });
  }

  useEffect(() => {
    setEditingSearches(favoriteSearches);
  }, [favoriteSearches]);

  return (
    <div className="ps-2 w-full truncate 2xl:ps-4 [@media(max-height:700px)]:ps-0 max-h-full pt-3 h-full overflow-hidden flex flex-col">
      <div
        className={`bg-transparent text-left flex justify-between items-center gap-2 pb-2 transition-all text-sm flex-col 2xl:flex-row  ${
          currPage === "search" ? "bg-gray-800 font-bold" : ""
        }`}
      >
        <div className="flex items-center gap-2">
          <Star className="!size-4" />
          Favorites
        </div>
        {!editing ? (
          <TooltipProvider>
            <Tooltip delayDuration={150}>
              <TooltipTrigger>
                <Pencil className="w-4" onClick={() => setEditing(true)} />
              </TooltipTrigger>
              <TooltipContent className="bg-gray-800 text-white">
                <p>Edit Favorites</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <div className="flex gap-2">
            <TooltipProvider>
              <Tooltip delayDuration={150}>
                <TooltipTrigger>
                  <Ban className="w-4" onClick={() => handleCancelClick()} />
                </TooltipTrigger>
                <TooltipContent className="bg-gray-800 text-white">
                  <p>Cancel Editing</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <TooltipProvider>
              <Tooltip delayDuration={150}>
                <TooltipTrigger>
                  <Save className="w-4" onClick={() => handleSaveClick()} />
                </TooltipTrigger>
                <TooltipContent className="bg-gray-800 text-white">
                  <p>Save Favorites</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
        )}
      </div>
      {editing ? (
        <SidebarFavoritesDraggableSection
          editingSearches={editingSearches}
          setEditingSearches={setEditingSearches}
        />
      ) : (
        <SidebarFavoritesDisplaySection />
      )}
    </div>
  );
};

export default SidebarFavorites;
